import { SET_FLOWS } from "./constants";

const initialState = {
  flows: [],
};

const Flows = (state = initialState, action) => {
  switch (action.type) {
    case SET_FLOWS:
      return { ...state, flows: action.payload };
    default:
      return state;
  }
};

export default Flows;
